// Vendors
import React from 'react';
// Components
import { LayoutComponent } from 'components/layout/layout.component';
// Constants
import { PAYMENT_LAYOUT_COMPONENT_PROPS } from './constants/payment.constants';
// Contexts
import { FetchErrorContextConsumerHOC } from 'contexts/fetch-error.context';
import { PaymentContextConsumerHOC } from './contexts/payment.context';
// Hooks
import { usePaymentHook } from './hooks/payment.hook';
// Styles
import { LayoutContentStyled } from 'styles/app.styled';
// Translations
import { PAYMENT_TITLE } from './translations/payment.translations';
// Views
import { PaymentLandingView } from './views/landing/payment-landing.view';

const PaymentBaseContainer = (): React.JSX.Element => {
  const { error, externalFetching } = usePaymentHook();

  return (
    <LayoutContentStyled>
      <LayoutComponent
        {...{ ...PAYMENT_LAYOUT_COMPONENT_PROPS, error, externalFetching }}
        title={PAYMENT_TITLE}
      >
        <PaymentLandingView />
      </LayoutComponent>
    </LayoutContentStyled>
  );
};

const PaymentContainer = PaymentContextConsumerHOC(
  FetchErrorContextConsumerHOC(PaymentBaseContainer)
);

export { PaymentContainer };
